const registrantFilterTechnique = {
    SEARCH_REGISTRANT: "SEARCH_REGISTRANT",
    QR_SCAN: "QR_SCAN",
};

export default registrantFilterTechnique;
